import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { SelectFacetTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/selectFacet.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: SelectFacetTrackingInfo) => {
    const event: TypedAnalyticsEvent<SelectFacetTrackingInfo> = {
        event: EventType.SelectFacet,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackFacet = (
    facetName: string,
    facetValue: string,
    index: string
) => {
    const trackingInfo: SelectFacetTrackingInfo = {
        filter: `${facetName}:${encodeURIComponent(facetValue)}`,
        index: index
    };

    track(trackingInfo);
};
